import axiosInstance from '../../services/api';

/**
 * IRIIS API Service
 * Fetches IRIIS external links for enemies
 */
export class IriisService {
  /**
   * Get IRIIS links for a list of enemy IDs
   * @param {string[]} enemyIds - Array of enemy UUIDs
   * @returns {Promise<Object>} Map of enemyId -> { url, title, dossier_type }
   */
  static async getEnemyLinks(enemyIds) {
    const { data } = await axiosInstance.get('/api/iriis/links/', {
      params: { enemy_ids: enemyIds.join(',') },
    });
    return data;
  }
}

/**
 * Query keys factory for IRIIS React Query cache management
 */
export const iriisKeys = {
  all: ['iriis'],
  links: () => [...iriisKeys.all, 'links'],
  enemyLinks: (enemyIds) => [...iriisKeys.links(), { enemyIds }],
};
